// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mdtQ","expireSoon":"styles_expireSoon__10Xhu"};